import React, { useState } from 'react';
import { faqItems } from '../data/mock';
import { ChevronDown, Search, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import JsonLd from '../components/JsonLd';

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

const FAQPage = () => {
  const [openQuestion, setOpenQuestion] = useState(faqItems[0]?.question || null);
  const [searchQuery, setSearchQuery] = useState('');

  const filteredFaq = faqItems.filter(
    (item) =>
      item.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.answer.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gray-50 pt-24">
      <JsonLd data={faqJsonLd} />
      {/* Header */}
      <section className="bg-gradient-to-r from-orange-600 to-orange-700 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Foire Aux Questions</h1>
          <p className="text-xl text-orange-200 max-w-2xl mx-auto">
            Trouvez rapidement les réponses à vos questions les plus fréquentes
          </p>
        </div>
      </section>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Search */}
        <div className="relative mb-8">
          <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
          <input
            type="text"
            placeholder="Rechercher une question..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-12 pr-4 py-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 text-lg"
          />
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {filteredFaq.map((item) => (
            <div
              key={item.question}
              className="bg-white rounded-xl overflow-hidden shadow-sm"
            >
              <button
                onClick={() => setOpenQuestion(openQuestion === item.question ? null : item.question)}
                className="w-full flex items-center justify-between p-6 text-left"
              >
                <span className="font-semibold text-gray-900 pr-4">{item.question}</span>
                <ChevronDown
                  className={`w-5 h-5 text-orange-500 flex-shrink-0 transition-transform ${
                    openQuestion === item.question ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openQuestion === item.question && (
                <div className="px-6 pb-6">
                  <p className="text-gray-600 leading-relaxed whitespace-pre-line">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {filteredFaq.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-500">Aucune question trouvée pour "{searchQuery}"</p>
          </div>
        )}

        {/* Contact CTA */}
        <div className="mt-12 bg-orange-100 rounded-2xl p-8 text-center">
          <MessageCircle className="w-12 h-12 text-orange-500 mx-auto mb-4" />
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            Vous n'avez pas trouvé votre réponse ?
          </h3>
          <p className="text-gray-600 mb-6">
            Notre équipe est là pour répondre à toutes vos questions
          </p>
          <Link
            to="/devis"
            className="inline-flex items-center gap-2 px-6 py-3 bg-orange-500 text-white font-medium rounded-full hover:bg-orange-600 transition-colors"
          >
            Contactez-nous
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
